import * as angular from 'angular';

function bigNumber() {
    return (val: number) => {
        if (val) {
            const splitted = val.toString().split(/(?=(?:...)*$)/);
            if (splitted.length > 1) {
                let res = '';
                for (let i = 0; i < splitted.length; i++) {
                    res += i !== splitted.length - 1 ? splitted[i] + ',' : splitted[i];
                }
                return res;
            }
            return val;
        }
        return undefined;
    };
}

angular
    .module('app.common')
    .filter('bigNumber', [bigNumber]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/big-number.filter.ts